import React, { useState } from "react";

import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";

export default function UnPinPostModal({ post, cancelModal, fetchdata }) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePinPost = async () => {
    setIsLoading(true);
    try {
      const pinResponse = await axios.post(
        `${ApiConnectionString}/api/ClubPost/Unpin/${post.id}`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (pinResponse.status === 200) {

        setComplete(true); // Indicate the operation was successful
        fetchdata();
      }
    } catch (error) {
      console.error("Error unpinning post:", error);
      // Optionally add user-facing error handling here
    } finally {
      setIsLoading(false); // Ensure the loading state is always reset
    }
  };
  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  }
  {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Post Unpinned</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>
            <p>The post has been successfully unpinned.</p>

            <div className="send-modal-footer">
              <button
                className="pointer cancelButton fw-bold mx-2 px-3"
                onClick={() => {
                  cancelModal();
                 
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Unpin Post</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <div>
              <strong className="red-text">{post.title}</strong>
              <p className="text-muted">{post.createdDate.substring(0, 10)}</p>
              <p>{post.content}</p>

              <p className="fw-bold">
                Are you sure you want to unpin this post?
              </p>
            </div>

            <div className="send-modal-footer">
              <button
                className="saveChanges-button mx-3"
                onClick={handlePinPost}
              >
                Confirm
              </button>
              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
